import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-copyright">
            © {new Date().getFullYear()} Algoheads.com All rights reserved.
          </div>
          <div className="footer-links">
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-link">Terms & Conditions</Link>
            <Link to="/refund" className="footer-link">Refund Policy</Link>
            <Link to="/blogs" className="footer-link">Blogs</Link>
            <Link to="/blogs#faq-section" className="footer-link">FAQ</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;